import React from "react";
import CTA from "./CTA";
import HeaderSocials from "./HeaderSocials";
import "./header.css";
import Type from "./Type";

const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hi, my name is</h5>
        <h1>Ujjwal kumar</h1>
        {/* <h5 className="text-light">Full-stack Developer</h5> */}
        <div className="text-typewriter" style={{}}>
          <span className="typewriter-span">I'm&nbsp;</span>
          <div>
            <Type />
          </div>
        </div>
        <CTA />
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
        <HeaderSocials />
      </div>
    </header>
  );
};

export default Header;
